import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import Swal from "sweetalert2";
import BaseMixer from "@/router/views/BaseMixer";
let HostileTakeoverConfirmationComponent = /** @class */ (() => {
    var _a, _b;
    let HostileTakeoverConfirmationComponent = class HostileTakeoverConfirmationComponent extends Mixins(BaseMixer) {
        deletionConfirmation() {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "popup-deactivate-title",
                    popup: "popup-deactivate",
                    icon: "remove-swal2-icon",
                },
                title: this.title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#556ee6",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Manage",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    return this.save();
                }
                return this.cancel();
            });
        }
        save() { }
        cancel() { }
        created() {
            this.deletionConfirmation();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof String !== "undefined" && String) === "function" ? _a : Object)
    ], HostileTakeoverConfirmationComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_b = typeof String !== "undefined" && String) === "function" ? _b : Object)
    ], HostileTakeoverConfirmationComponent.prototype, "text", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HostileTakeoverConfirmationComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HostileTakeoverConfirmationComponent.prototype, "cancel", null);
    HostileTakeoverConfirmationComponent = __decorate([
        Component({
            name: "HostileTakeoverConfirmationComponent",
            components: {},
        })
    ], HostileTakeoverConfirmationComponent);
    return HostileTakeoverConfirmationComponent;
})();
export default HostileTakeoverConfirmationComponent;
